import React from 'react';

import AlertBottomSheet from 'components/AlertBottomSheet';
import ConfirmationModal from 'components/ConfirmationModal';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { ConfirmMessage } from 'models/confirmMessage';

import { Text } from './styles';

interface Props {
  showConfirm?: boolean;
  onConfirmClose?: () => void;
  onConfirmApprove?: () => void;
  confirmMessage?: ConfirmMessage;
  showCancelButton: boolean;
}

const ConfirmApproveModal = ({
  showConfirm,
  onConfirmClose,
  onConfirmApprove,
  confirmMessage,
  showCancelButton,
}: Props) => {
  const { t } = useStoreTranslation();
  if (!showConfirm) return <></>;
  if (!onConfirmClose) return <></>;
  if (!onConfirmApprove) return <></>;

  return confirmMessage?.button ? (
    <ConfirmationModal
      open={showConfirm}
      title={confirmMessage?.title ?? ''}
      onClose={onConfirmClose}
      onConfirm={onConfirmApprove}
      confirmButton={confirmMessage.button}
      highlight={true}
      showCancelButton={showCancelButton}
    >
      <Text>{confirmMessage?.text}</Text>
    </ConfirmationModal>
  ) : (
    <AlertBottomSheet
      show={showConfirm}
      close={t('confirmationModal.cancel')}
      title={confirmMessage?.title ?? ''}
      onClose={onConfirmClose}
      highlight={true}
    >
      <Text>{confirmMessage?.text}</Text>
    </AlertBottomSheet>
  );
};
export default ConfirmApproveModal;
